import React, { useEffect, useState } from 'react';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';

type Props = { filters: any };

const StatCard: React.FC<{ title: string; primary: string; secondary?: string; icon?: React.ReactNode }>=({ title, primary, secondary }) => (
  <div className="kpi">
    <div className="meta">
      <div>{title}</div>
      <div className="value">{primary}</div>
      {secondary && <div className="sub">{secondary}</div>}
    </div>
  </div>
);

const StatsRow: React.FC<Props> = () => {
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [newCustomers30, setNewCustomers30] = useState(0);
  const [totalQueries, setTotalQueries] = useState(0);
  const [newQueries30, setNewQueries30] = useState(0);
  const [followupsToday, setFollowupsToday] = useState(0);
  const [last30BookedAmt, setLast30BookedAmt] = useState(0);
  const [last30PaidAmt, setLast30PaidAmt] = useState(0);

  const { data } = useDashboardData();
  useEffect(() => {
    if (!data) return;
    setTotalCustomers(data.stats.customersTotal || 0);
    setNewCustomers30(data.stats.customersNew30 || 0);
    setTotalQueries(data.stats.queriesTotal || 0);
    setNewQueries30(data.stats.queriesNew30 || 0);
    setFollowupsToday(data.stats.followupsToday || 0);
    setLast30BookedAmt(data.stats.bookedAmt30 || 0);
    setLast30PaidAmt(data.stats.paidAmt30 || 0);
  }, [data]);

  return (
    <div className="kpi-grid">
      <StatCard title="Customers" primary={`${totalCustomers}`} secondary={`+${newCustomers30} in last 30d`} />
      <StatCard title="Queries" primary={`${totalQueries}`} secondary={`+${newQueries30} in last 30d`} />
      <StatCard title="Follow-ups Today" primary={`${followupsToday}`} />
      <StatCard title="Bookings vs Payments (30d)" primary={`₹${(last30PaidAmt/1000).toFixed(1)}k / ₹${(last30BookedAmt/1000).toFixed(1)}k`} />
    </div>
  );
};

export default StatsRow;
